import axios from 'axios';
import store from '@/store';

const initialState = () => ({
  ratings: null
});

const formHeaders = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };

export default {
  namespaced: true,
  state: initialState,
  getters: {
    ratings: (state) => state.ratings || []
  },
  mutations: {
    SET_RATING(state, ratings) {
      state.ratings = ratings;
    },
    ADD_RATING(state, rating) {
      state.ratings = [...(state.ratings || []), rating];
    }
  },
  actions: {
    async isRated({ commit, state }, args) {
      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const contacto_id = store.state.Auth.user.userId;

      const params = {
        attributes: [
          'calendario_id', 'clase_id', 'calificacion', 'comentario'
        ].join(',')
      };

      try {
        const response = await axios.get(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + `alumni/contactos/${contacto_id}/calendarios/${args.calendar_id}/resumenes-calificaciones`,
          {
            ...options,
            params
          }
        );

        commit('SET_RATING', response.data.data);
        return response.data.data
      } catch (err) {
        console.error(err);
      }
    },
    async rate({ commit, state }, args) {
      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const contacto_id = store.state.Auth.user.userId;

      const params = {
        calificacion: args.calificacion,
        ...(args.comentario?.trim() && {
          comentario: args.comentario.trim()
        })
      };

      try {
        const response = await axios.post(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + `alumni/contactos/${contacto_id}/calendarios/${args.calendario_id}/clase/${args.clase_id}/resumen-calificacion`,
          params,
          options
        );

        commit('ADD_RATING', {
          calendario_id: Number(args.calendario_id),
          clase_id: Number(args.clase_id),
          calificacion: Number(args.calificacion),
          comentario: args.comentario
        });

        return response.data
      } catch (err) {
        console.error(err);
      }
    }
  },
};
